import { SidebarInset, SidebarProvider } from '@data-delivery/d3s';
import { Outlet } from 'react-router-dom';
import { AppSidebar } from './components/app-sidebar';
import { SiteHeader } from './components/site-header';

export function SidebarLayout() {
  return (
    <div className='[--header-height:calc(theme(spacing.14))]'>
      <SidebarProvider className='flex flex-col'>
        <SiteHeader />
        <div className='flex flex-1'>
          <AppSidebar />
          <SidebarInset>
            <div className='flex flex-1 flex-col gap-4 px-2'>
              <Outlet />
            </div>
          </SidebarInset>
        </div>
      </SidebarProvider>
    </div>
  );
}
